import React, { createContext, useReducer } from "react";
import { notificationsReducer } from "../reducers/notificationsReducer";

export const NotificationsContext = createContext();

const NotificationsContextProvider = (props) => {
  const [notifications, dispatch] = useReducer(notificationsReducer, []);

  return (
    <NotificationsContext.Provider value={{ notifications, dispatch }}>
      {props.children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsContextProvider;
